import React from 'react';
import i18n from 'i18n-js';
import { useDispatch } from 'react-redux';
import { vehicleActions } from 'state/modules/vehicles';
import Images from 'components/Images';

const VehicleImages = ({ id }) => {
  const dispatch = useDispatch();

  const onSetProfileImage = (payload) => {
    dispatch(vehicleActions.setVehicleProfileImage(id, payload));
  };

  const onDeleteImages = (payload) => {
    dispatch(vehicleActions.deleteVehicleImages(id, payload));
  };

  const onUploadImage = (payload) => {
    dispatch(vehicleActions.uploadVehicleImage(id, payload));
  };

  const onReset = () => {
    dispatch(vehicleActions.resetUploadVehicleImage());
  };

  return (
    <Images
      id={id}
      title={i18n.t('vehicle.vehicle_images')}
      onSetProfileImage={onSetProfileImage}
      onDeleteImages={onDeleteImages}
      onUploadImage={onUploadImage}
      onReset={onReset}
      sourceType="vehicle"
    />
  );
};

export default VehicleImages;
